import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
//import { store } from '../redux/store';
// Note: If you still need translations slice, you can add it to redux/slices
// import { mergeTranslations } from '../redux/slices/translationsSlice';
import heTranslation from '../locales/he/translation.json';
import enTranslation from '../locales/en/translation.json';

// Initialize with default translations
const resources = {
  he: {
    translation: heTranslation,
  },
  en: {
    translation: enTranslation,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'he', // Hebrew as primary language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Function to merge server translations
export const mergeServerTranslations = (
  serverTranslations: Record<string, Record<string, string>>
) => {
  // Update Redux store if you have translations slice
  // store.dispatch(mergeTranslations(serverTranslations));

  // Update i18next resources
  Object.keys(serverTranslations).forEach((lang) => {
    if (i18n.hasResourceBundle(lang, 'translation')) {
      const existing = i18n.getResourceBundle(lang, 'translation');
      i18n.addResourceBundle(
        lang,
        'translation',
        { ...existing, ...serverTranslations[lang] },
        true,
        true
      );
    } else {
      i18n.addResourceBundle(
        lang,
        'translation',
        serverTranslations[lang],
        true,
        true
      );
    }
  });
};

export default i18n as typeof i18n & { t: (key: string, options?: any) => string };

